import {
    FETCH_MATCHING_PROFILES,
    FETCH_MATCHING_PROFILES_SUCCESS,
    FETCH_MATCHING_PROFILES_FAILED,
} from '../actions/actionTypes/onboarding-action-types';

const initialState = {
    profiles: [],
    isLoading: false,
    isLoaded: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_MATCHING_PROFILES:
            return {
                ...state,
                isLoaded: false,
                isLoading: true,
            };
        case FETCH_MATCHING_PROFILES_SUCCESS:
            return {
                ...state,
                profiles: action.payload.data,
                isLoaded: true,
                isLoading: false,
            };
        case FETCH_MATCHING_PROFILES_FAILED:
            return {
                ...state,
                profiles: [],
                isLoaded: true,
                isLoading: false,
            };
        default:
            return state;
    }
};
